export const FIELD = {
  KEYWORD: 'keyword',
  CLICKS: 'clicks',
  IMPRESSIONS: 'impressions',
  CTR: 'ctr',
  LISTING_ID: 'listingId',
  LISTING_NAME: 'listingName'
}

export const FIELD_MAP = {
  [FIELD.KEYWORD]: '關鍵字',
  [FIELD.CLICKS]: '點擊量',
  [FIELD.IMPRESSIONS]: '曝光量',
  [FIELD.CTR]: '點擊率(%)',
  [FIELD.LISTING_ID]: '賣場編號',
  [FIELD.LISTING_NAME]: '賣場名稱'
}

export const SORT_OPTIONS = [
  {
    id: FIELD.CLICKS,
    value: FIELD.CLICKS,
    text: FIELD_MAP[FIELD.CLICKS]
  },
  {
    id: FIELD.IMPRESSIONS,
    value: FIELD.IMPRESSIONS,
    text: FIELD_MAP[FIELD.IMPRESSIONS]
  },
  {
    id: FIELD.CTR,
    value: FIELD.CTR,
    text: FIELD_MAP[FIELD.CTR]
  }
]
